import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationPT from "./translations/translationPT.json";
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources: {
			pt: {
				translation: translationPT,
			},
		},
		lng: "pt", // if you're using a language detector, do not define the lng option
		fallbackLng: "pt",

		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
